export default "__VITE_ASSET__DDm98cNI__";